import { z } from "zod";

export const emailSchema = z.string().email("Zadejte platný email");
export const passwordSchema = z.string().min(6, "Heslo musí mít alespoň 6 znaků");
export const accessCodeSchema = z.string().min(1, "Přístupový kód je povinný");

export const accountKindSchema = z.enum(["customer", "partner"]);

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});
export type LoginInput = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: passwordSchema,
    accessCode: accessCodeSchema,
    acceptedTerms: z.boolean().refine((accepted) => accepted, {
      message: "Pro registraci je nutný souhlas s podmínkami",
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Hesla se neshodují",
    path: ["confirmPassword"],
  });
export type RegisterInput = z.infer<typeof registerSchema>;

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: passwordSchema,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Hesla se neshodují",
    path: ["confirmPassword"],
  });
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
